import React from "react"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"

const ModalListingSkeleton = () => {
   return (
      <div className="production-line-skeleton ">
         <div className="production-line-skeleton-row align-items-end">
            <UnitSkeleton shape="rounded" size="small" />
         </div>
         <div className="production-line-skeleton-row ">
            <UnitSkeleton shape="rounded" size="large" />
            <UnitSkeleton shape="rounded" size="large" />
            <UnitSkeleton shape="rounded" size="large" />
         </div>
      </div>
   )
}

export default ModalListingSkeleton
